import { render, staticRenderFns } from "./MdPatientContactsBox.vue?vue&type=template&id=f3b18afa&scoped=true&"
import script from "./MdPatientContactsBox.vue?vue&type=script&lang=js&"
export * from "./MdPatientContactsBox.vue?vue&type=script&lang=js&"
import style0 from "./MdPatientContactsBox.vue?vue&type=style&index=0&id=f3b18afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b18afa",
  null
  
)

export default component.exports